<template>
  <span
    class="field-help"
    v-if="(v.$error && cleardata) && !v[error.validator]">
    {{ error.message }}
  </span>
</template>

<script>
  export default {
    props: {
      error: { type: Object, required: true, default: undefined },
      v: { type: Object, required: true, default: undefined },
    },
    data() {
      return {
         cleardata: true,
      };
    },
    mounted() {
      window.eventBus.$on('clearError', (flag) => {
        this.cleardata = flag;
      });
    },
  };
</script>

<style lang='scss' src="./field-help.scss"></style>
